<script setup lang="ts">
import {watch} from 'vue';
import {Translation as I18nT} from 'vue-i18n';
import BalmDialog from '@/vue/atoms/balm-dialog.vue';
import BalmBtn from '@/vue/atoms/balm-btn.vue';

defineProps<{
  email?: string;
}>();

const emit = defineEmits<{
  close: [],
}>();

const opened = defineModel<boolean>({required: true});

// The dialog is non-persistent (no-x), so it can also be dismissed via ESC or a
// backdrop click — not just the close button. Emit `close` on every close path so
// the parent always routes through the post-verification redirect to login.
watch(opened, (isOpen) => {
  if (!isOpen) {
    emit('close');
  }
});

function dismiss(): void {
  opened.value = false;
}
</script>
<template>
  <balm-dialog
    v-model="opened"
    theme="neutral-0"
    type="fit-content"
    :no-x="true"
    :blur-backdrop="true"
  >
    <div class="verification">
      <h2>{{ $t('email_verification') }}</h2>
      <i18n-t keypath="email_verification_text" tag="p" class="verification-text">
        <template #email>
          <strong>{{ email }}</strong>
        </template>
      </i18n-t>
      <p class="verification-spam">
        {{ $t('email_verification_spam') }}
      </p>
      <balm-btn
        class="verification-close"
        :label="$t('email_verification_close')"
        theme="grey"
        @click="dismiss"
      />
    </div>
  </balm-dialog>
</template>
<style scoped lang="scss">
.verification {
  display: flex;
  flex-direction: column;
  gap: var(--Spacing-spacing-4);
  padding: var(--Spacing-spacing-4);
}

// Serif display face per the Figma dialog title (font-h2 rendered the
// primary sans instead).
h2 {
  @include font-display-3;
}

.verification-spam {
  color: var(--Neutral-UI-neutral-ui-70);
  font-size: var(--Typography-Body-SM);
}

.verification-close {
  align-self: flex-end;
}
</style>
